import styled from 'styled-components'
import { Link } from '@chegg/fanta'
import { colors } from '@chegg-ui/theme'
import { ProjectItemMenu } from '@chegg-wt/core/components/ProjectItemMenu/styled'
import fanta from '@chegg-wt/core/theme/fanta/theme'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

export const ListItemDateText = styled.span`
  color: ${colors.grey};
  font-size: ${fanta.font.text.size.xs};
  white-space: nowrap;
  line-height: 35px;
`

export const ProjectListItem = styled.div`
  display: flex;
  color: ${colors.dark};
  border: ${({ theme }) => `1px solid ${theme.colors.greyDDD}`};
  font-size: ${({ theme }) => theme.font.text.size.lg};
  background-color: ${({ theme }) => theme.colors.white};
  margin-bottom: 16px;
  box-shadow: 0 0 4px 0 rgba(34, 34, 34, 0.2);
  padding: 8px 12px 8px 24px;
  justify-content: space-between;
  flex-direction: column;
  height: 85px;
  cursor: pointer;
  ${AspiraStack};
  text-decoration: none;
  @media (min-width: 900px) {
    height: 52px;
    flex-direction: row;
  }

  &:hover,
  &:focus-within {
    ${ProjectItemMenu} {
      padding-top: 2px;
    }

    box-shadow: 0 0 4px 0 rgba(34, 34, 34, 0.4);
    text-decoration: none;
  }
`

export const ListItemLink = styled.a`
  display: flex;
  color: ${colors.dark};
  border: ${({ theme }) => `1px solid ${theme.colors.greyDDD}`};
  font-size: ${({ theme }) => theme.font.text.size.lg};
  background-color: ${({ theme }) => theme.colors.white};
  margin-bottom: 16px;
  box-shadow: 0 0 4px 0 rgba(34, 34, 34, 0.2);
  padding: 8px 12px 8px 24px;
  justify-content: space-between;
  flex-direction: column;
  height: 78px;
  cursor: pointer;
  ${AspiraStack};
  text-decoration: none;
  @media (min-width: 900px) {
    height: 52px;
    flex-direction: row;
  }
  &:hover {
    box-shadow: 0 0 4px 0 rgba(34, 34, 34, 0.4);
    text-decoration: none;
  }
`

export const ListItemLinkWithMenu = styled.a`
  display: inline-block;
  width: 100%;
  text-decoration: none;
`
export const ListItemName = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: min-content;
  cursor: pointer;
  max-width: 580px;
  padding-right: 15px;
`

export const List = styled.ul`
  text-align: start;
  margin: 0;
`

export const ListContainer = styled.div<{ loadingContainer?: boolean }>`
  display: flex;
  flex-direction: column;
  background-color: ${colors.skyXlight};
  box-sizing: border-box;
  border-top: 2px solid ${colors.greyLight};
  width: 100%;
  padding: 24px 24px 0px;
  justify-content: center;
  height: ${({ loadingContainer }) => (loadingContainer ? '324px' : 'auto')};
`

export const SeeAllLink = styled.a.attrs({
  children: 'See all',
})`
  color: ${colors.link};
  font-size: ${fanta.font.text.size.sm};
  ${AspiraStack};
  font-weight: bold;
  cursor: pointer;
  align-self: flex-end;
  margin-bottom: ${fanta.spacing.fanta.md};
  &:hover {
    text-decoration: underline;
  }
`

export const TextContainer = styled.div`
  text-align: center;
  font-weight: bold;
  margin-bottom: 40px;
`

export const CtaLink = styled(Link)`
  &&& {
    ${AspiraStack};
    font-weight: ${fanta.font.weight.extraBold};
    color: ${colors.link};
  }
`

export const CtaAnchor = styled(Link)`
  &&& {
    ${AspiraStack};
    font-weight: ${fanta.font.weight.extraBold};
    color: ${colors.link};
    cursor: pointer;
  }
`

export const EmptyCitationList = styled.div``
